import React, { useState } from 'react'
import { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Form, InputPicker, SelectPicker, Table, TagPicker } from 'rsuite';
import queueService from '../../../services/Internal/Queue/queue.service';
import entityService from '../../../services/Internal/Staff/entity.service';
import { getInternalStatuses } from '../../../services/Shared/codeTable.service';

function GridSearch(props) {
    const [statuses, setStatuses] = useState([]);
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const [employeeList, setEmployeeList] = useState([]);
    const [applicationTypes, setApplicationTypes] = useState([]);
    useEffect(() => {
        if (props.propsIsActive) {
            entityService.plsGetStaffAndAdmin().then((response) => {
                setEmployeeList(response.data.map((item, i) => {
                    return { "label": `${item.firstName} ${item.lastName}`, "value": `${item.id}` }
                }).filter((item, index, self) =>
                    index === self.findIndex((i) => (
                        i.value === item.value
                    ))
                ));
            });
            queueService.getApplicationTypes().then((response) => {
                setApplicationTypes(response.data.map((x, i) => { return { "label": `${x}`, "value": `${x}` } }));
            })
            if (props.hasInternalStatusSearch) {
                getInternalStatuses().then(setStatuses);
            }
        }
    }, [props.propsIsActive])

    return (
        <Form formValue={props.searchModel} onChange={props.setSearchModel} onSubmit={props.handleSearch} fluid>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>First Name</b></Form.ControlLabel>
                        <Form.Control name="firstName" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Last Name</b></Form.ControlLabel>
                        <Form.Control name="lastName" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.ControlLabel><b>Organization Name</b></Form.ControlLabel>
                        <Form.Control name="organizationName" />
                    </Form.Group>
                </Col>
                {props.hasInternalStatusSearch &&
                    <Col>
                        <Form.Group>
                            <Form.ControlLabel className="text-left"><b>Internal Status</b></Form.ControlLabel>
                            <Form.Control
                                block
                                accepter={SelectPicker}
                                searchable={false}
                                data={statuses}
                                name="internalStatus" />
                        </Form.Group>
                    </Col>
                }
            </Row>
            {
                (showAdvancedSearch && props.hasAdvancedSearch) &&
                <>
                    <Row className="mt-2">
                        <Col>
                            <Form.Group>
                                <Form.ControlLabel><b>Assigned To</b></Form.ControlLabel>
                                <Form.Control
                                    block
                                    accepter={SelectPicker}
                                    searchable={false}
                                    data={employeeList}
                                    name="assignedTo" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.ControlLabel><b>Submitted Date Range</b></Form.ControlLabel>
                                <Form.Control name="dateSubmittedBegin" type="date" block />
                            </Form.Group>
                        </Col>
                        <Col xs="auto" style={{ marginTop: '1.5em' }} className="d-flex align-items-center">to</Col>
                        <Col>
                            <Form.ControlLabel>&nbsp;</Form.ControlLabel>
                            <Form.Control name="dateSubmittedEnd" type="date" block />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col>
                            <Form.Group>
                                <Form.ControlLabel><b>Application Type</b></Form.ControlLabel>
                                <Form.Control block accepter={TagPicker} data={applicationTypes} name="applicationType" />
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            }
            <hr />
            {props.hasAdvancedSearch ?
                <>{showAdvancedSearch ?
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={() => { setShowAdvancedSearch(false); props.clearSearchModel(); }} className="me-2">Simple Search</Button>
                        <Button onClick={props.clearSearchModel} variant="danger" className="me-2">Reset</Button>
                        <Button type="submit">Search</Button>
                    </div>
                    :
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={() => { setShowAdvancedSearch(true); }} className="me-2">Advanced Search</Button>
                        <Button type="submit">Search</Button>
                    </div>
                }
                </>
                :
                <div style={{ textAlign: 'right' }}>
                    <Button type="submit">Search</Button>
                </div>
            }
        </Form>
    );
}

export default GridSearch;